window.addEventListener("DOMContentLoaded", function () {
  // console.log("DOM fully loaded and parsed");
  // setTimeout(function () {
  //   const crossSell = document.querySelector(
  //     '#shopify-section-product-main limespot-box[data-box-type="CrossSell"]'
  //   );
  //   console.log(crossSell);
  //   if (crossSell !== null) {
  //     crossSell.classList.add("show-cross-sell");
  //   }
  // }, 5000);
  this.window.addEventListener("scroll", function () {
    this.document.querySelector(
      "main ~ div .needsclick.kl-private-reset-css-Xuajs1"
    );
    if (
      this.document.querySelector(
        "main ~ div .needsclick.kl-private-reset-css-Xuajs1"
      ) !== null
    ) {
      this.document
        .querySelector("main ~ div .needsclick.kl-private-reset-css-Xuajs1")
        .classList.add("show-klaviyo-form");
    }
  });
});

$(document).ready(function() {
  $('p:has(> img:only-child):not(:has(> *:not(img)))')
  .html(function(index, oldHtml) {
    return oldHtml.replace(/&nbsp;/g, '');
  })
  .addClass('article-image-wrapper');

    $('body').on('click', '.bg-overlay', function() {
      $('body').removeClass('navbar-open');
      $('#main_nav').removeClass('show');
    });


});